import { makeBetterEnum } from './betterEnum';

export const GhgScope = makeBetterEnum(
  'Scope1',
  'Scope2',
  'Scope3',
  'CarbonRemoval',
  'AdditionalCleanPower'
);

export type GhgScope = (typeof GhgScope)[keyof typeof GhgScope];
